import { render, staticRenderFns } from "./videoiframe.vue?vue&type=template&id=3b02750d&"
import script from "./videoiframe.vue?vue&type=script&lang=js&"
export * from "./videoiframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b02750d')) {
      api.createRecord('3b02750d', component.options)
    } else {
      api.reload('3b02750d', component.options)
    }
    module.hot.accept("./videoiframe.vue?vue&type=template&id=3b02750d&", function () {
      api.rerender('3b02750d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ucUNClvcoYqO/JS/videoiframe.vue"
export default component.exports